<section *ngIf="hospitalesPageInformacion" class="card">
    <p-toolbar styleClass="mb-4 gap-2">
        <ng-template pTemplate="left">
            <button pButton pRipple [label]="'Excel'" icon="pi pi-file-excel" class="p-button-success"
                (click)="exportExcel()"></button>
        </ng-template>

    </p-toolbar>
    <p-table [value]="hospitalPage" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
            <tr>
                <th>Hospital</th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-hospital>
            <tr>

                <td>{{hospital.nomHospital}}</td>
                <td></td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="2" class="text-center p-4">
                    <div class="flex flex-column align-items-center">
                        <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                        <span class="text-600 mt-2">No se encontraron hospitales</span>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <div class="card flex justify-content-center">
        <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows"
            [totalRecords]="totalRecords"></p-paginator>
    </div>
</section>